export const environment = {
    production: false,
    apiURL: 'https://api-qa.day1cloud.com/api',
    loginApp: 'https://login-qa.day1cloud.com',    
    ping: 'https://openam-day1cloud-use1-sandbox.id.forgerock.io',
    host: 'https://demoapp-qa.day1cloud.com',
    clientId: 'ext_sp_demo_app_qa',
    oauth: {
        clientId: 'MyProfile',
        issuer: 'https://risk-detection-router-api-qa-ct5ogq.rajrd4-1.usa-e1.cloudhub.io'
    }    
}